const state = {
  m_modalInfo: {
    obj: null,
    type: "",
    name: "",
    component: null
  },
  m_dialogInfo: {
    obj: null,
    message: "",
    type: "",
    name: "",
    component: null
  },
  resultVal: false
};

const actions = {
  /* 모달 팝업 호출 */
  showModal({ state, commit }, modal) {
    commit("setModalParams", modal);
    let mWidth = "";
    let mHeight = "";

    if (modal.type == "org") {
      mWidth = "1020px";
      mHeight = "700px";
    } else if (modal.type == "duplicate") {
      mWidth = "500px";
      mHeight = "180px";
    } else if (modal.type == "fileUpload") {
      mWidth = "700px";
      mHeight = "500px";
    } else if (modal.type == "createGroup") {
      mWidth = "700px";
      mHeight = "600px";
    } else if (modal.type == "share") {
      mWidth = "700px";
      mHeight = "500px";
    } else if (modal.type == "groupSetting") {
      mWidth = "600px";
      mHeight = "500px";
    } else if (modal.type == "searchCoGroup") {
      mWidth = "700px";
      mHeight = "400px";
    } else if (modal.type == "createAssignment") {
      mWidth = "700px";
      mHeight = "500px";
    } else if (modal.type == "Viewer") {
      //      mWidth = "1830px";
      //      mHeight = "800px";
      mWidth = modal.data.mWidth;
      mHeight = modal.data.mHeight;
    } else if (modal.type == "registBoard") {
      mWidth = "700px";
      mHeight = "500px";
    } else {
      mWidth = "1000px";
      mHeight = "700px";
    }

    modal.obj.show(
      modal.component,
      {
        modal: modal.obj,

        name: modal.name,
        modalInfo: modal.data
      },
      {
        width: mWidth,
        height: mHeight
      }
    );
  },
  showDialog({ commit }, dialog) {
    commit("setDialogParams", dialog);
    let mWidth = "350px";
    let mHeight = "150px";

    dialog.obj.show(
      dialog.component,
      {
        modal: dialog.obj,
        name: dialog.name,
        message: dialog.message,
        btnName1: dialog.btnName1,
        btnName2: dialog.btnName2
      },
      {
        width: mWidth,
        height: mHeight
      }
    );
  },
  showToast(context, toast) {
    toast.obj.show(toast.message, toast.options);
  },
  setResultVal({ commit }, resultVal) {
    commit("setResultVal", resultVal);
  }
};
const mutations = {
  setModalParams(state, modal) {
    state.m_modalInfo.name = modal.name;
    state.m_modalInfo.type = modal.type;
    state.m_modalInfo.value = modal.value;
    state.m_modalInfo.component = modal.component;
    state.m_modalInfo.mWidth = modal.width;
    state.m_modalInfo.mHeight = modal.height;
  },
  setDialogParams(state, dialog) {
    state.m_dialogInfo.message = dialog.message;
    state.m_dialogInfo.type = dialog.type;
    state.m_dialogInfo.name = dialog.name;
    state.m_dialogInfo.component = dialog.component;
  },
  setResultVal(state, resultVal) {
    state.resultVal = resultVal;
  }
};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
};



// WEBPACK FOOTER //
// ./src/js/store/modules/modal.js